import React, {Component} from 'react'

class NoneCustomDomainForm extends Component {

    constructor(props, context) {
        super(props, context)
    }

    render() {

      const { openRegisterForm } = this.props

        return (

          <fieldset className="fld_domain">
                <legend className="screen_out">개인 도메인 설정</legend>
                <div className="item_set">
                  가비아, 후이즈 등 도메인 등록 업체에서 구입한 도메인을 연결할 수 있습니다.
                  <label className="lab_btn lab_domain">
                    <span className="txt_btn">도메인 연결하기</span>
                    <input type="button" className="btn_g" accept=".ico" onClick={openRegisterForm}/>
                  </label>
                </div>
              </fieldset>

        )
    }
}

export default NoneCustomDomainForm
